import React from "react";
import { Skeleton } from "@mui/material";
import { useRouter } from "next/router";
import ProfileMainBodyLoader from "./ProfileMainBodyLoader";

const ProfileMainLoader = () => {
  const router = useRouter();

  const { projectSlug } = router.query as { projectSlug: string[] | undefined };

  return (
    <div className="index-profile-main-content container">
      <div className="profile-listing-cards">
        <div className="title-and-new">
          <h2 className="large-text">
            <Skeleton style={{ width: 91 }} />
          </h2>
        </div>
        <div className="type-and-sort">
          <div className="tab-header tab-header-loading">
            <Skeleton style={{ height: "100%" }} />
          </div>
        </div>

        <ProfileMainBodyLoader projectSlug={projectSlug} />
      </div>
    </div>
  );
};

export default ProfileMainLoader;
